export const useLongTokenAnnotations = (
  annotations: RevisionAnnotations,
  paragraph: Paragraph,
  tokenGroup: ParagraphToken[]
) => {
  return annotations.filter((annotation) => {
    if (
      paragraph.firstTokenGlobalPosition == undefined ||
      paragraph.lastTokenGlobalPosition == undefined
    ) {
      return null;
    }

    if (annotation.tokenGlobalPositions.length == 0) {
      return false;
    }

    const lastTokenGlobalPosition =
      annotation.tokenGlobalPositions[
        annotation.tokenGlobalPositions.length - 1
      ];

    // Now we check to see if this lastTokenGlobalPosition is within the tokenGroup
    const index = tokenGroup.findIndex(
      (token) => token.globalPosition == lastTokenGlobalPosition
    );

    // If the index is not in the group, we want to skip it.
    if (index < 0) {
      return false;
    }

    return useIsAnnotationCommentLong(annotation);
  });
};
